export default function setScrollbarCssVariables() {
    const scroller = document.scrollingElement;
    scroller.style.setProperty('overflow', 'scroll');
    requestAnimationFrame(()=>{
        scroller.style
            .setProperty(
                '--vw',
                scroller.clientWidth / 100,
            );
        scroller.style
            .setProperty(
                '--vh',
                window.innerHeight / 100,
            );
        scroller.style
            .setProperty(
                '--scrollbar-width',
                window.innerWidth - scroller.clientWidth,
            );
        scroller.style
            .setProperty(
                'overflow',
                '',
            );
    });
}
